import { Helmet } from "react-helmet";
import { Link } from 'react-router-dom';

const AboutUs = () => {
  return (
    <>
        <Helmet>
            <title>About Us | Freelity</title>
            <meta
            name="description"
            content="Learn about Freelity's mission to provide free, fast, and reliable online tools to everyone — with no sign-ups or limitations."
            />
            <meta name="robots" content="index, follow" />
            <link rel="canonical" href="https://freelity.com/about" />
        </Helmet>
        <section className="sec-free-tools termsconditions">
            <div className="container">

                <h1 className="text-center">About Us</h1>
                <p><strong>Last Updated:</strong> May 16, 2025</p>

                <h3>1. Welcome Message</h3>
                <p>
                    Welcome to <strong>Freelity</strong> — a free platform built with one simple goal:
                    <strong> to help people by providing useful online tools without any cost.</strong>
                </p>

                <h3>2. Our Vision</h3>
                <p>
                    Everyone deserves access to simple, reliable, and fast tools — without sign-ups or unnecessary limits.
                    We display a few ads to keep this platform free forever.
                </p>

                <h3>3. Who We Serve</h3>
                <p>
                    Whether you are a student, developer, freelancer, or just someone looking for quick solutions,
                    Freelity offers tools that save your time and effort.
                </p>

                <h3>4. Transparency</h3>
                <p>
                    This website is independently managed and regularly updated with new tools and improvements
                    to make your life easier.
                </p>

                <h3>5. Thank You</h3>
                <p>
                    Thank you for using Freelity. Your support and feedback help us grow and stay motivated to build more
                    for the community.
                </p>

                <h3>6. Contact Us</h3>
                <p>
                    Feel free to <Link to="/contact">Contact Us</Link> anytime with suggestions,
                    bug reports, or tool ideas.
                </p>
            </div>
        </section>
    </>
  );
};

export default AboutUs;
